import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'validateNextBtn'
})
export class ValidateNextBtnPipe implements PipeTransform {

  transform(value: any): boolean {
    let aux = false;
    if (!value.isMulti && !value.respuesta) aux = true;
    if (value.isMulti && !value.respuestaMulti.some(x => x.isCheck)) aux = true;
    return aux;
  }
}
